
@switch (columnId) {
  @case ('amount') {
    <lib-text-table-column>
      {{ element.amount | vituCurrencyUsd }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="element.amount ?? 0"></lib-table-column-sort>
  }
  @case ('refNumber') {
    <lib-text-table-column>
      {{ element.refNumber }}
    </lib-text-table-column>
  }
  @case ('status') {
    <lib-status-chip
      class="funding-item-settlement-statuses"
      [status]="element.status">
    </lib-status-chip>
  }
  @case ('type') {
    <lib-text-table-column>
      {{ element.type }}
    </lib-text-table-column>
  }
  @default {
  }
}
